<template>
    <div class="mainBox">
      <RightContent :smallType="id" :bigTitle="name"></RightContent>
    </div>
  </template>
  
  
  <script>
   import RightContent from "@/components/common/RightContent";
   import axios from "axios";
   
   export default {
    components: {
        RightContent
      },
    data(){
          return{
              id:"",
              name:""
          }
    }, 
    created:function(){
      let id = this.$route.params.id;
      let that = this;
      this.id = id;
      axios.get(this.COMMON.httpUrl + '/api/articleType/info', {
              params: {
                id: id,
              }
            }).then(function (response) {
              var data = response.data;
              if(data.code==200){
                var info = data.data[0];
                // console.log(info);
                that.name = info.name;
              }
             
            }).catch(function (error) {
              console.log(error)
            });
    } 
  }
  </script>
  
  
  <style>
  
  </style>
  